import { render } from "./ResultatComposition.vue?vue&type=template&id=42f4e9c6&scoped=true&ts=true"
import script from "./ResultatComposition.vue?vue&type=script&lang=ts"
export * from "./ResultatComposition.vue?vue&type=script&lang=ts"

import "./ResultatComposition.vue?vue&type=style&index=0&id=42f4e9c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f4e9c6"]])

export default __exports__